module.exports = __webpack_public_path__ + "img/go.9a6318a1.svg";